import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import elImageCloseOnMask from './plugins/elImageCloseOnMask'
import './assets/css/global.css';
import './assets/css/premium-theme.css';
import './assets/css/obsidian-violet-theme.css';
import './assets/css/picell-light-theme.css';
import './assets/css/invite-members-theme.css';
import './assets/css/department-dialog-theme.css';
import './assets/fonts/iconfont.css';
import { downloadOssFile } from '@/utils/ossDownload'

// 明亮模式是产品的默认外观；只有用户明确保存过深夜模式时才启用深夜。
const savedThemeMode = localStorage.getItem('aimpress-theme-mode')
document.documentElement.dataset.theme = savedThemeMode === 'dark' ? 'dark' : 'light'

// 👇 核心：引入封装好的 request
import request from '@/utils/request'

// Pinia
import { createPinia } from 'pinia'
const pinia = createPinia()

const app = createApp(App)
app.config.globalProperties.$downloadOssFile = downloadOssFile

// 👇 全局挂载：所有页面直接用 proxy.$request / this.$request
app.config.globalProperties.$http = request

// 注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia)
app.directive('image-close-on-mask', elImageCloseOnMask)
app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.mount('#app')

// 开发环境兼容
if (process.env.NODE_ENV === 'development') {
  const originalResizeObserver = window.ResizeObserver
  window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        setTimeout(() => {
          callback(entries, observer)
        }, 0)
      })
    }
  }
}
